module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/ignite-session-15-nov-2025.json
// module id = 1355
// module chunks = 127261004005480